import { buildClassMap } from '../utilities/buildClassMap';
import { DefaultFontStyles } from '../styles/DefaultFontStyles';
/**
 * {@docCategory FontClassNames}
 */
export var FontClassNames = buildClassMap(DefaultFontStyles);
//# sourceMappingURL=FontClassNames.js.map